export default "__VITE_ASSET__Bpuco97b__"